import { render, staticRenderFns } from "./StatutCommandeIcon.vue?vue&type=template&id=61585f9a"
import script from "./StatutCommandeIcon.vue?vue&type=script&lang=js"
export * from "./StatutCommandeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports